import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/pages/index'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: Index,
  meta: {
    title: '个人信息收集清单',
  },
}, {
  path: '/userInfo',
  component: () => import('@/pages/userInfo'),
  meta: {
    title: '个人信息',
  },
}, {
  path: '/applyInfo',
  component: () => import('@/pages/applyInfo'),
  meta: {
    title: '使用信息',
  },
}, {
  path: '/deviceInfo',
  component: () => import('@/pages/deviceInfo'),
  meta: {
    title: '设备信息',
  },
}]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router